import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import type { IxcPortfolioV1TransactionState } from '@interxfi/types';
import { PageTabRail } from '../../../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import {
  type PortalTabbedNavigationTab,
  TabbedNavigationGroup,
} from '../../../../../../../../../../../../components/router/router-tabbed-navigation';
import { PortfolioTransactionsTable } from '../../../../../../../../../../../../features/portfolio/transaction/portfolio-transactions-table';
import { AccountPortfolioCashEquivalentsLayout } from '../../../../../../../../../../../../features/registration/account/portfolio-value/cash-equivalents/account-portfolio-cash-equivalents-layout';
import { getResolvedPath } from '../../../../../../../../../../../../util/routing/entity-paths';
import type { ViewContext } from '../../../../../../../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/transaction/_transaction/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.RegistrationAccountCashEquivalents,
      label: 'Transactions',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.RegistrationAccountCashEquivalents>,
  component: AccountCashEquivalentsTransactionList,
});

function tableLinkBuilder(row: IxcPortfolioV1TransactionState) {
  return getResolvedPath('/registration/account/$accountId/cash/transaction/$transactionId', row);
}

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.RegistrationAccountCashEquivalents}
    />
  );
}

function AccountCashEquivalentsTransactionList() {
  const { accountId } = Route.useParams();
  const viewContext: ViewContext = useMemo(
    () => ({
      kind: 'account',
      accountId,
    }),
    [accountId],
  );

  return (
    <AccountPortfolioCashEquivalentsLayout accountId={accountId}>
      <PortfolioTransactionsTable HeaderActions={TableHeader} linkBuilder={tableLinkBuilder} view={viewContext} />
    </AccountPortfolioCashEquivalentsLayout>
  );
}
